export default {
  // Appointment Status
  'appointment-status.booked': 'Der Termin wurde gebucht und bestätigt',
  'appointment-status.canceled': 'Der Termin wurde storniert',
  'appointment-status.missed': 'Sie haben den Termin verpasst',
  'appointment-status.finished': 'Der Termin wurde wahrgenommen',
  'appointment-status.ongoing': 'Der Termin ist in Gange',
  'appointment-status.pending': 'Terminbestätigung Ausstehend',
  'appointment-status.reserved': 'Dieser Termin ist für Sie reserviert',
  'appointment-status.requested': 'Der Termin wurde angefragt',
  'appointment-status.not-yet-pending': 'Termin noch nicht freigegeben',

  // Appointment status short
  'appointment-status.booked.short': 'Gebucht',
  'appointment-status.canceled.short': 'Storniert',
  'appointment-status.missed.short': 'Verpasst',
  'appointment-status.finished.short': 'Abgeschlossen',
  'appointment-status.ongoing.short': 'Laufend',
  'appointment-status.pending.short': 'Ausstehend',
  'appointment-status.reserved.short': 'Reserviert',
  'appointment-status.requested.short': 'Angefragt',
  // TODO
  'appointment-status.not-yet-pending.short': 'Noch nicht ausstehend',

  // Relationships
  'relationship.child': 'Kind',
  'relationship.friend': 'Freund',
  'relationship.other': 'Nicht spezifiziert',
  'relationship.parent': 'Elternteil',
  'relationship.sibling': 'Geschwister',
  'relationship.spouse': 'Ehepartner*in',

  // Relationship status
  'relationship.status.active': 'Aktiv',
  'relationship.status.paused': 'Pausiert',
  'relationship.status.pending-ward-approval': 'In Bestätigung',
  'relationship.status.pending-legal-guardian-approval': 'In Bestätigung',

  // Relationship status description
  'relationship.status.active.description': 'Die Vormundschaft ist aktiv.',
  'relationship.status.paused.description':
    'Während die Vormundschaft pausiert ist, können keine Aktionen durch den Vormund durchgeführt werden.',
  'relationship.status.pending-ward-approval.description':
    'Bestätigung vonseiten des Mündels ausstehend.',
  'relationship.status.pending-legal-guardian-approval.description':
    'Bestätigung vonseiten des gesetzlichen Vormundes ausstehend.',

  // Appointment request status short
  'appointment-request.approved.short': 'Bestätigt',
  'appointment-request.cancelled.short': 'Storniert',
  'appointment-request.created.short': 'Erstellt',
  'appointment-request.fulfilled.short': 'Gebucht',
  'appointment-request.in-proposal.short': 'Terminauswahl ausstehend',
  'appointment-request.submitted.short': 'Gesendet',
  'appointment-request.rejected.short': 'Abgelehnt',
  'appointment-request.proposal-rejected.short': 'Terminvorschläge abgelehnt',

  'appointment-request.location.in-person': 'Persönlich',
  'appointment-request.location.video': 'Video',
  'appointment-request.location.phone': 'Telefon',
  'appointment-request.location.none': '',

  // Appointment Reuqest status
  'appointment-request.approved': 'Die Terminanfrage wurde durch die Einrichtung bestätigt.',
  'appointment-request.cancelled': 'Die Terminanfrage wurde storniert.',
  'appointment-request.created': 'Terminanfrage erstellt',
  'appointment-request.fulfilled': 'Termin wurde gebucht.',
  'appointment-request.in-proposal': 'Bestätigung der Terminvorschläge ausstehend.',
  'appointment-request.submitted': 'Die Terminanfrage wurde an die Einrichtung weitergeleitet.',
  'appointment-request.rejected': 'Die Terminanfrage wurde von der Einrichtung abgelehnt.',
  'appointment-request.proposal-rejected': 'Terminvorschläge wurden auf Patientenseite abgelehnt.',
  'appointment-request.rejected.no-reason':
    'Die Terminanfrage wurde von der Einrichtung ohne Angabe von Gründen abgelehnt.',
  // Appointment request status description
  'appointment-request.approved.description':
    'Ihre Terminanfrage wurde von der ausgewählten Einrichtung bestätigt.',
  'appointment-request.cancelled.description': 'Die Terminanfrage wurde von Ihnen storniert.',
  'appointment-request.created.description':
    'Terminanfrage wurde erstellt aber noch nicht versandt.',
  'appointment-request.fulfilled.description':
    'Es wurde erfolgreich ein Termin zu Ihrer Anfrage gebucht. Diesen können Sie oben einsehen.',
  'appointment-request.in-proposal.description':
    'Bitte lassen Sie die ausgewählte Einrichtung wissen, welcher Termin für Sie am besten infrage kommt. Diese können Sie unten auswählen.',
  'appointment-request.submitted.description':
    'Die von Ihnen ausgewählte Einrichtung hat die Terminanfrage erhalten und wird diese in Kürze bearbeiten.',
  'appointment-request.rejected.description':
    'Die ausgewählte Einrichtung hat Ihren Termin abgelehnt.',
  'appointment-request.proposal-rejected.description':
    'Sie haben angegeben, dass Sie keinen der von der ausgewählten Einrichtung vorgeschlagenen Termine annehmen können.',
  'appointment-request.archived.description':
    'Die ausgewählte Einrichtung hat Ihren Termin archiviert.',
  'appointment-request.archived.short': 'Archiviert',
  'appointment-request.archived': 'Terminanfrage archiviert.',

  // Week days
  'weekday.monday': 'Montag',
  'weekday.tuesday': 'Dienstag',
  'weekday.wednesday': 'Mittwoch',
  'weekday.thursday': 'Donnerstag',
  'weekday.friday': 'Freitag',
  'weekday.saturday': 'Samstag',
  'weekday.sunday': 'Sonntag',

  // Sex
  'sex.male': 'Männlich',
  'sex.female': 'Weiblich',
  'sex.diverse': 'Divers',

  'sex.m': 'M',
  'sex.w': 'W',
  'sex.x': 'X',

  'month.january': 'Januar',
  'month.february': 'Februar',
  'month.march': 'März',
  'month.april': 'April',
  'month.may': 'Mai',
  'month.june': 'Juni',
  'month.july': 'Juli',
  'month.august': 'August',
  'month.september': 'September',
  'month.october': 'Oktober',
  'month.november': 'November',
  'month.december': 'Dezember',
};
